










import { Vue, Component, Prop } from "vue-property-decorator";
export interface MessageProps {
  text: string;
  value: boolean;
  closeText?: string;
  callback?: () => {} | undefined;
  showBtn?: boolean;
  timeout: number;
  color?: string;
}

@Component
export default class Message extends Vue {
  options: MessageProps = {
    text: "",
    timeout: 5000,
    value: false,
    closeText: "Close",
    showBtn: true,
    callback: undefined,
    color: "#CE2664"
  };
  show(options: MessageProps) {
    options.value = true;
    this.options = Object.assign(this.options, options);
  }
  hide() {
    this.options.value = false;
  }
  close() {
    this.options.value = false;
    this.options.callback ? this.options.callback() : "";
  }
}
